import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

const POPULAR_TAG = 'popular';
const MAX = 100;

@Injectable({
  providedIn: 'root'
})
export class KnowledgeService {

  constructor(private httpService: HttpService) { }

 
  private postsPath = 'posts';
  private categoryPath = 'categories';
  private tagPath = 'tags'
  private mediaPath = 'media'

  formatPostUrl(pageSize, pageNo, category, search) {
    if (category) {
        return (search
            ? `${this.postsPath}?per_page=${pageSize}&page=${pageNo}&categories=${category}&search=${encodeURIComponent(search)}`
            : `${this.postsPath}?per_page=${pageSize}&page=${pageNo}&categories=${category}`);
    }
    return (search
        ? `${this.postsPath}?per_page=${pageSize}&page=${pageNo}&search=${encodeURIComponent(search)}`
        : `${this.postsPath}?per_page=${pageSize}&page=${pageNo}`);
}

  getPosts(pageSize: number, pageNo: number, category: string | null, search: string | null): Observable<any>{
    const url = this.formatPostUrl(pageSize, pageNo, category, search);
    return this.httpService.httpGet(url).pipe(response => {
      return response;
    });
  }

  getPopularPosts(pageSize: number, pageNo: number, category: string | null, search: string | null, tagId: number): Observable<any>{
    const url = this.formatPostUrl(pageSize, pageNo, category, search);
    return this.httpService.httpGet(`${url}&tags=${tagId}`).pipe(response => {
      return response;
    });
  }

  getCategories(): Observable<any>{
    return this.httpService.httpGet(`${this.categoryPath}?per_page=${MAX}` ).pipe(response => {
      return response;
    });
  }

  getSubCategoriesb(id: string): Observable<any>{
    return this.httpService.httpGet(`${this.categoryPath}?parent=${id}&per_page=${MAX}`).pipe(response => {
      return response;
    });
  }

  getPopularTageId(): Observable<any>{
    return this.httpService.httpGet(`${this.tagPath}?search=${POPULAR_TAG}`).pipe(response => {
      return response;
    });
  }

  getPostDetails(id: number): Observable<any>{
    return this.httpService.httpGet(`${this.postsPath}/${id}`).pipe(response => {
      return response;
    });
  }

  getPostAttachments(id: number): Observable<any>{
    return this.httpService.httpGet(`${this.mediaPath}?parent=${id}`).pipe(response => {
      return response;
    });
  }

  getTags(): Observable<any>{
    return this.httpService.httpGet(this.tagPath).pipe(response => {
      return response;
    });
  }
 
}
